export const GET_USER_DETAIL_ATTRIBUTIONS = 'GET_USER_DETAIL_ATTRIBUTIONS'
export const SET_USER_DETAIL_ATTRIBUTIONS = 'SET_USER_DETAIL_ATTRIBUTIONS'

export function getAttributions ({ uuid }) {
  return {
    type: GET_USER_DETAIL_ATTRIBUTIONS,
    payload: { uuid },
  }
}

export function setAttributions ({ uuid, data, error }) {
  return {
    type: SET_USER_DETAIL_ATTRIBUTIONS,
    payload: { uuid, data, error },
  }
}
